import { Injectable } from "@angular/core";
import { getLocaleCurrencyName } from "@angular/common";
import { environment } from "../environments/environment";

@Injectable()
export class Globals {
  role: string = "";
  local: boolean = getLocale(); // for file access
  localParse: boolean = getLocaleParse(); // used for Parse DB connection
}

function getLocale() {
  let isLocal = environment.isLocal;

  // if(JSON.parse(localStorage.getItem("isLocal"))==null){
  //   isLocal = true
  // }else{
  //   isLocal = JSON.parse(localStorage.getItem("isLocal"))
  // }
  // console.log("sofiane ",isLocal)
  return isLocal;
}

function getLocaleParse() {
  // local front of scanners
  // for all tchek scans light, we get 
  return environment.isLocalParse;
}



// WEBPACK FOOTER //
// ./src/app/GlobalsExport.ts